<template>
    <div class="upload">
        <Form :labelWidth="100" :model="formData">
            <FormItem class="margin-bottom-15" label="附件类型">
                <Select v-model="formData.attachType" @on-change="getAccept">
                    <Option
                        v-for="item in attachTypeList"
                        :key="item.key"
                        :value="item.value"
                    >{{item.label}}</Option>
                </Select>
            </FormItem>
        </Form>
        <div class="text-center margin-bottom-20">ShippingLabel、PackingList、BOL三种类型支持格式为：PNG、JPG、PDF；Other格式不限</div>
        <compMutiUpload v-bind="getFileProps" @on-success="uploadSuccess" @on-cancel="cancelUpload" />
    </div>
</template>
<script>
import { HttpUploadAttachments } from '@/service/destory'
export default {
    props: ['id'],
    data() {
        return {
            formData: {
                attachType: 'Other'
            },
            fileList: []
        };
    },
    computed: {
        attachTypeList() {
            return [
                {
                    label: "Other",
                    value: "Other",
                    accept: ''
                },
                {
                    label: "ShippingLabel",
                    value: "ShippingLabel",
                    accept: '.png,.jpg,.pdf'
                },
                {
                    label: "PackingList",
                    value: "PackingList",
                    accept: '.png,.jpg,.pdf'
                },
                {
                    label: "BOL",
                    value: "BOL",
                    accept: '.png,.jpg,.pdf'
                },
            ];
        },
        getFileProps() {
            return {
                action: process.env.VUE_APP_APIURL_FBB + '/api/v2/OrderAttach/attachmentUpload',
				name: "multipartFile",
				data: {
					attachType: this.formData.attachType,
                    orderId: this.id ? this.id : '',
                    orderType: 6000
				},
                accept: this.formData.accept,
                multiple: false,
                formatter: (res, item) => {
                    return res.data
                }
                // format: this.formData.format
            };
        },
    },
    methods: {
        getAccept (value) {
            this.formData.accept = this.attachTypeList.filter(item => {
                return item.value === value
            })[0].accept
        },
        uploadSuccess (data) {
            this.fileList.push({
                ...data
            })
            this.$emit('on-success', this.fileList)
        },
        cancelUpload () {
            this.$emit('on-cancel')
        }
    }
};
</script>

<style>
</style>